// Plugin de la liste du dropsel à partir du select existant

(function ( $ ) {

    $.fn.ddContainer = function() {
        return $(this).each(function(){
            var $that = $(this),
                $ddButton = $that.find('.js-dropsel-btn'),
                $ddList = $that.find('.js-dropsel'),
                // $select = $that.find('.js-select'),
                $options = $that.find('.js-select option'),
                $current=$that.find('.js-select option:selected'),
                showLabel = $that.is('.js-dropsel-label'),
                selected,
                currentValue;

            $ddList.empty();

            selected = $current.text();
            if (showLabel) {
                currentValue = $current.data('class');
                currentHex = $current.data('hex');
            }

            $options.each(function() {
                var text = $(this).text(),
                    value = $(this).val(),
                    hex=$(this).data('hex');



                if (!showLabel) {
                    $ddList.append('<li tabindex="0" class="js-dropsel-item" data-value="'+value+'">' + text + '</li>');
                } else {
                    var labelClass = $(this).data('class');

                    $ddList.append('<li tabindex="0" class="js-dropsel-item dropsel-label" style="--hex:'+hex+'" data-hex="'+hex+'"  data-value="'+value+'">' + text + '</li>');
                }

            });
            $ddList.find('.js-dropsel-item').ddItem();
            $ddButton.text(selected);

            if (showLabel) {
                console.log(currentHex)
                $ddButton.get(0).style.setProperty('--hex',currentHex)
                $ddButton.addClass("dropsel-label")
            }

        });
    };

}( jQuery ));


// Plugin du bouton du dropsel

(function ( $ ) {

    $.fn.ddButton = function() {
        return $(this).each(function(){
            var $dropsel = $(this).next();

            $(this).on('click', function(e){
                e.preventDefault();
                e.stopPropagation();
                keydown = 0;

                $('.js-dropsel').not($dropsel).removeClass('open');
                $(this).next().toggleClass('open');
            });
        });
    };

}( jQuery ));


// Plugin d'un élement de liste

(function ( $ ) {

    $.fn.ddItem = function() {
        var $configuratorLogos = $('.configurator_products_logo');

        return $(this).on('click', function(){
            var value = $(this).data('value'),
                $parent = $(this).parent();

            keydown = 0;

            $parent.toggleClass('open');
            $parent.prevAll('.js-select').val(value).trigger('change');

            if ($configuratorLogos.length > 0) {
                $configuratorLogos.each(function() {
                    var currentHref = $(this).attr('href');
                    var newHref = currentHref.replace(/&fer=[^&]*/, '&fer=' + value);
                    $(this).attr('href', newHref);
                });
            }
        });
    };

}( jQuery ));


// Plugin du select

(function ( $ ) {

    $.fn.ddSelect = function() {
        return $(this).each(function(){
            var $that = $(this),
                showLabel = $that.parent().is('.js-dropsel-label');

            $that.on('change', function(){
                var value = $that.find('option:selected').val(),
                    text = $that.find('option:selected').text(),
                    classes = $that.next().attr("class").split(' ');

                $that.next().text(text);
                if (showLabel) {
                    var labelClass = $that.find('option:selected').data('class'),
                    currentHex = $that.find('option:selected').data('hex');
                    $.each(classes, function(i, c) {
                        if (c.indexOf("dropsel-label-") == 0) {
                            $that.next().removeClass(c);
                        }
                    });
                    $that.next().get(0).style.setProperty('--hex',currentHex)
                }
            });

            $that.on('focus', function(){
                maxWidthMd(function(){},function(){
                    $that.next().click();
                });
            });
        })
    };

}( jQuery ));

(function ( $ ) {

    $.fn.ddList = function() {
        return $(this).each(function(){
            $(this).hover(function(){
                $('.js-body').css('overflow', 'hidden');
            }, function(){
                $('.js-body').css('overflow', 'auto');
            });
        });
    };

}( jQuery ));

$(function() {

    ww = $(window).width();

    $(window).resize(function(){
        ww = $(window).width();
    })

    if ($('.js-dropsel-container').length) {
        $('.js-dropsel-container').ddContainer();
    }

    if ($('.js-dropsel-btn').length) {
        $('.js-dropsel-btn').ddButton();
    }

    if ($('.js-select').length) {
        $('.js-select').ddSelect();
    }

    if ($('.js-dropsel').length) {
        $('.js-dropsel').ddList();
    }

    $(document).keyup(function(e) {
        var dropOpen = $('.js-dropsel.open').length ? true : false;

        if (dropOpen) {
            if (e.keyCode == 40 || e.keyCode == 9) {
                e.preventDefault();
                e.stopPropagation();

                var num = $('.js-dropsel.open li').length;

                if (keydown < num) {
                    keydown++;
                }

                $('.js-dropsel.open li:nth-child('+ keydown +')').focus();

            } else if (e.keyCode == 38) {
                e.preventDefault();
                e.stopPropagation();

                if (keydown > 1) {
                    keydown--;
                }

                $('.js-dropsel.open li:nth-child('+ keydown +')').focus();

            } else if (e.keyCode == 13) {
                e.preventDefault();
                e.stopPropagation();

                $('.js-dropsel.open li:nth-child('+ keydown +')').click();
            }
        }
    });

    $('.js-body').on('click', function(){
        if ($('.js-dropsel').length) {
            $('.js-dropsel').removeClass('open');
        }
    });
});
